import MenuIcon from './MenuIcon'
import SaveIcon from './SaveIcon'
import MoreIcon from './MoreIcon'
import WarningIcon from './WarningIcon'
import ShowIcon from './ShowIcon'
import CloseIcon from './CloseIcon'
import CancelCircleIcon from './CancelCircleIcon'
import ContractIcon from './ContractIcon'
import ImpactArrowIcon from './ImpactArrowIcon'
import AuditIcon from './AuditIcon'
import ApiIcon from './ApiIcon'
import KeyIcon from './KeyIcon'
import HelpIcon from './HelpIcon'
import NotificationIcon from './NotificationIcon'
import AccountIcon from './AccountIcon'
import AddIcon from './AddIcon'
import RestoreIcon from './RestoreIcon'
import CheckIcon from './CheckIcon'
import ArrowDownIcon from './ArrowDownIcon'
import DownloadIcon from './DownloadIcon'
import OKIcon from './OKIcon'
import BigErrorIcon from './BigErrorIcon'
import SettingsIcon from './SettingsIcon'
import ErrorIcon from './ErrorIcon'
import TopicSharingIcon from './TopicSharingIcon'
import ExportIcon from './ExportIcon'
import CrossIcon from './CrossIcon'
import LoaderIcon from './LoaderIcon'
import SearchIcon from './SearchIcon'
import HideIcon from './HideIcon'
import BaselineAndroid from './BaselineAndroid'
import InfoCircleIcon from './InfoCircleIcon'
import WarnCircleIcon from './WarnCircleIcon'
import ArrowUpIcon from './ArrowUpIcon'
import TopicThreadHuntingIcon from './TopicThreadHuntingIcon'
import CloudService from './CloudServiceIcon'
import TopicManageAndSettingsIcon from './TopicManageAndSettingsIcon'
import TopicOverviewIcon from './TopicOverviewIcon'
import TopicPcManagementIcon from './TopicPcManagementIcon'
import TargetIcon from './TargetIcon'
import AlertWarning16 from "./AlertWarning16Icon";
import AlertWarning16Icon from "./AlertWarning16Icon";
import AlertWarning32Icon from "./AlertWarning32Icon";
import AlertSuccess16Icon from "./AlertSuccess16Icon";
import AlertSuccess32Icon from "./AlertSuccess32Icon";
import AlertSuccessTransparentIcon from "./AlertSuccessTransparentIcon"
import AlertBlock16Icon from "./AlertBlock16Icon";
import AlertCritical16Icon from "./AlertCritical32Icon";
import AlertCritical32Icon from "./AlertCritical32Icon";
import RadiusIcon from "./RadiusIcon";
import SamlIcon from "./SamlIcon";
import AlertWarningBorderIcon from "./AlertWarningBorderIcon";
import TopicAssetsUsersDevicesIcon from './TopicAssetsUsersDevicesIcon';
import IdpAdfsIcon from './IdpAdfsIcon';
import IdpAzureIcon from './IdpAzureIcon';
import IdpOktaIcon from './IdpOktaIcon';
import IdpOneloginIcon from './IdpOneloginIcon';
import IdpPingIcon from './IdpPingIcon';
import IdpGenericSamlIcon from "./IdpGenericSamlIcon";
import AlertError16Icon from "./AlertError16Icon";
import AlertError32Icon from "./AlertError32Icon";
import AlertHelp16Icon from "./AlertHelp16Icon";
import AlertHelp32Icon from "./AlertHelp32Icon";
import AlertInfo16Icon from "./AlertInfo16Icon";
import AlertInfo32Icon from "./AlertInfo32Icon";
import AlertErrorTransparentIcon from "./AlertErrorTransparentIcon";
import IdpDuoIcon from "./IdpDuoIcon";
import QuarantinePasscodeIcon from "./QuarantinePasscodeIcon";
import NewTabIcon from "./NewTabIcon";

export default {
  'baseline-android': BaselineAndroid,
  'account': AccountIcon,
  'add': AddIcon,
  'arrow-down': ArrowDownIcon,
  'arrow-up': ArrowUpIcon,
  'cancel-circle': CancelCircleIcon,
  'info,info-circle': InfoCircleIcon,
  'warning,warn-circle': WarnCircleIcon,
  'check': CheckIcon,
  'close': CloseIcon,
  'cross': CrossIcon,
  'error,error-cirle,issues': ErrorIcon,
  'hide': HideIcon,
  'loader': LoaderIcon,
  'notification': NotificationIcon,
  'commit,ok,big_v': OKIcon,
  'restore': RestoreIcon,
  'save': SaveIcon,
  'search': SearchIcon,
  'show': ShowIcon,
  'download': DownloadIcon,
  'big_error': BigErrorIcon,
  'menu': MenuIcon,
  'settings': SettingsIcon,
  'audit': AuditIcon,
  'license,contract': ContractIcon,
  'key': KeyIcon,
  'export': ExportIcon,
  'help': HelpIcon,
  'more,vertical-dots': MoreIcon,
  'api': ApiIcon,
  'topic-sharing,mssp': TopicSharingIcon,
  'impact-arrow,impact_arrow': ImpactArrowIcon,
  'warning': WarningIcon,
  'topic-thread-hunting':TopicThreadHuntingIcon,
  'cloud-service': CloudService,
  'topic-manage-and-settings': TopicManageAndSettingsIcon,
  'topic-overview': TopicOverviewIcon,
  'topic-pc-management': TopicPcManagementIcon,
  'target': TargetIcon,
  'alert-warning-16': AlertWarning16Icon,
  'alert-warning-32': AlertWarning32Icon,
  'alert-warning-border': AlertWarningBorderIcon,
  'alert-success-16': AlertSuccess16Icon,
  'alert-success-32': AlertSuccess32Icon,
  'alert-success-transparent': AlertSuccessTransparentIcon,
  'alert-block-16': AlertBlock16Icon,
  'alert-critical-16': AlertCritical16Icon,
  'alert-critical-32': AlertCritical32Icon,
  'alert-error-16': AlertError16Icon,
  'alert-error-32': AlertError32Icon,
  'alert-error-transparent': AlertErrorTransparentIcon,
  'alert-help-16': AlertHelp16Icon,
  'alert-help-32': AlertHelp32Icon,
  'alert-info-16': AlertInfo16Icon,
  'alert-info-32': AlertInfo32Icon,
  'radius': RadiusIcon,
  'saml': SamlIcon,
  'topic-asset-users-devices': TopicAssetsUsersDevicesIcon,
  'idp-adfs': IdpAdfsIcon,
  'idp-azure': IdpAzureIcon,
  'idp-okta': IdpOktaIcon,
  'idp-onelogin': IdpOneloginIcon,
  'idp-ping': IdpPingIcon,
  'idp-duo': IdpDuoIcon,
  'idp-generic-saml': IdpGenericSamlIcon,
  'quarantine-passcode': QuarantinePasscodeIcon,
  'new-tab': NewTabIcon,
}
